<template>
  <div class="pack-content" @mouseup="mouseupHandler" @touchend="mousedownHandler" @mousemove="mouseupHandler" @touchmove="mouseupHandler">
    <loading v-show="loading"></loading>
    <div v-if="inited" v-show="!loading" class="card-list-group">
      <div class="card-item" @mousedown="mousedownHandler(card)" @touchstart="mousedownHandler(card)"
           :class="card.classList" v-for="(card,index) in cards" :style="cardStyle(card)" :key="index">
        <div class="bg-cover" :class="isCardActive(card)?'active':''" :style="'background-color: '+card.bgColor"></div>
        <component class="card-inner" :is="card.component" :card-data="card"></component>
      </div>
    </div>
  </div>
</template>
<script>
  import loading from '@/components/common/loading.vue'
  import {mapState} from 'vuex';
  import poductCard from './product-card.vue';
  import detailCard from './detail-card.vue';
  import qrcodeCard from './qrcode-card.vue';
  import swiperCard from './swiper-card.vue';
  import cardsStyle from '@/enums/cardStyle.js'
  export default {
    components: {loading},
    data(){
      return {
        loading: true,
        packCode: '', //包码
        isExistProduct: false, //是否存在关联的产品
        productList: [], //产品列表
        existData: null, //关联产品信息
        activeCard: null,
        inited: false
      };
    },
    computed: mapState({
      indexCardsSize(state){
        return state.indexCardsSize
      },
      cards(){
        const list = [];
        if (this.isExistProduct) {
          list.push({component: swiperCard, productData: this.existData, activeEnable: false, classList: ['swiper-card-item'], bgColor: '#bb1d48'});
          list.push({component: detailCard, productData: this.existData, activeEnable: false, classList: ['detail-card-item'], bgColor: '#d1462f'});
        }
        list.push({component: qrcodeCard, code: this.packCode, activeEnable: false, classList: ['qrcode-card-item'], bgColor: '#8531dd'});
        const colorLength = cardsStyle.cardBackgroundColor.length;
        this.productList.forEach((item, index) => {
          const bgColor = cardsStyle.cardBackgroundColor[index % colorLength];
          list.push({component: poductCard, productData: item, activeEnable: true, bgColor, classList: ['product-card-item']});
        });
        return list;
      }
    }),
    methods: {
      cardStyle(card){
        let style = {};
        const {indexCardsSize} = this;
        if (card.component === swiperCard) {
          style = {...indexCardsSize.max, left: 0, top: 0};
        } else if (card.component === detailCard) {
          style = {...indexCardsSize.large, left: 6, top: 0};
        } else {
          let left = 0;
          let top = 0;
          const index = this.cards.indexOf(card);
          if (this.isExistProduct) {
            if (index === 2) {
              left = 6;
              top = 4.26;
            } else if (index === 3) {
              left = 9;
              top = 4.26;
            } else {
              left = Math.floor((index - 4) / 2) * 3 + 12;
              if (index % 2 === 0) {
                top = 0
              } else {
                top = 4.26;
              }
            }
          } else {
            left = Math.floor(index / 2) * 3;
            if (index % 2 === 0) {
              top = 0;
            } else {
              top = 4.26;
            }
          }
          style = {...indexCardsSize.normal, left, top};
        }
        Object.keys(style).forEach(key => {
          style[key] = style[key] + 'rem';
        });
        return style;
      },
      mousedownHandler(card){
        if (card.activeEnable) {
          this.activeCard = card;
        }
      },
      mouseupHandler(){
        this.activeCard = null;
      },
      async packCodeQueryCheck(){
        const {packCode: code} = this;
        const res = await this.$ajax.jsonp(this.$urlAPI.BaseData.PackCodeQueryCheck, {code});
        if (res.Result == 200) {
          this.isExistProduct = !!res.Data.IsExistProduct;
        }
      },
      isCardActive(card){
        return card === this.activeCard;
      },
      async getPackBatchProductList(){
        const {packCode: code} = this;
        const res = await this.$ajax.jsonp(this.$urlAPI.BaseData.GetPackBatchProductList, {code});
        if (res.Result == 200) {
          this.existData = res.Data.product;
          this.productList = res.Data.list;
        }
      },
      async init(){
        //加载包码信息
        const packCode = localStorage.getItem('packCode');
        this.packCode = packCode;
        await this.packCodeQueryCheck();
        await this.getPackBatchProductList();
        this.loading = false;
        //设置title
        if (this.existData) {
          localStorage.setItem('ProductName', this.existData.ProductName);
        }
        this.$store.commit('setPageTitle', '溯源结果');
        this.$store.commit('resizeCardsSize');
        this.inited = true;
        await this.$nextTick();
        this.changeGestureState();
      },
      changeGestureState(){
        let state = false;
        this.cards.forEach(card => {
          const style = this.cardStyle(card);
          const left = style.left.replace('rem', '') * 1;
          const width = style.width.replace('rem', '') * 1;
          const htmlFontSize = this.$store.state.htmlFontSize;
          const absLeft = (left + width) * htmlFontSize;
          if (absLeft > this.$el.offsetWidth) {
            state = true;
          }
        });
        this.$store.commit('changeGestureState', state);
      }
    },
    created(){
      this.init();
    }
  }
</script>
<style rel="stylesheet/less" lang="less" scoped>
  .pack-content {
    position: relative;
    height: 100%;
    margin: 0 50px;
    overflow: auto;
  }

  .card-item {
    position: absolute;
    left: 0;
    top: 0;
    .bg-cover, .card-inner {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .bg-cover {
      &.active {
        opacity: 0.7;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?29d2fecc